<template>
  <div id="app">
    <AppLoader v-if="appLoaderVisible">
      CHARGEMENT
    </AppLoader>
    <AppNotification v-else />
    <router-view />
  </div>
</template>

<script>
  import AppLoader from './components/AppLoader';
  import AppNotification from './components/AppNotification';
  import 'smartbanner.js/dist/smartbanner.min.js';

  export default {
    name: 'App',
    components: { AppLoader, AppNotification },
    computed: {
      appLoaderVisible() {
        return this.$store.state.appLoader.isVisible;
      },
    },
    mounted() {
      let html = document.querySelector('html')
      html.style.marginTop = '0px'
    },
  };
</script>

<style lang="scss" src="./assets/style.scss" />

<style lang="scss">
  @import "../node_modules/smartbanner.js/dist/smartbanner.min.css";

  * {
    box-sizing: border-box;
  }

  html {
    font-size: 10px;
    font-family: $_fontGotham;
    color: $textColor;
  }

  h1 {
    margin-bottom: 5rem;
  }

  .smartbanner {
    top: auto;
    bottom: 0;
  }

  .smartbanner.smartbanner--hellocare {
    position: fixed;
    z-index: 2147483002;
    box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.5);
    top: auto;
    bottom: 0;
    .smartbanner__icon {
      left: 1.5rem;
    }

    .smartbanner__info {
      font-family: $_fontRoboto;
      right: 4rem;
      left: 9.2rem;
      width: auto;
    }

    .smartbanner__info__title,
    .smartbanner__info__author,
    .smartbanner__info__price {
      font-size: 1.5rem;
      line-height: 2rem;
    }

    .smartbanner__info__author,
    .smartbanner__info__price {
      font-weight: 300;
    }

    .smartbanner__button {
      top: 0;
      right: 3rem;
      bottom: 0;
      left: 0;
      padding: 0;
      background-color: transparent;
    }

    .smartbanner__button__label {
      display: none;
    }

    .smartbanner__exit {
      top: 0.5rem;
      right: 0.5rem;
      left: auto;
      padding: 10px;
      border-radius: 50%;
      background-color: black;

      &::before,
      &::after {
        top: 4px;
        left: 9px;
        width: 2px;
        background-color: white;
      }
    }
  }
</style>

<style scoped lang="scss">
  #app {
    font-size: 1.6rem;
  }
</style>
